import React from 'react';
import { View, Text, TouchableOpacity, Modal } from 'react-native';
import { usePopup } from '../contexts/PopupContext';

export function ConfirmationDialog() {
  const { confirmation, handleConfirm, handleCancel } = usePopup();

  if (!confirmation.visible) return null;

  return (
    <Modal
      transparent={true}
      visible={confirmation.visible}
      animationType="fade"
    >
      <View style={{
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10000
      }}>
        <View style={{
          backgroundColor: '#2c3e50',
          borderRadius: 10,
          padding: 20,
          minWidth: 300,
          maxWidth: '90%',
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 2 },
          shadowOpacity: 0.25,
          shadowRadius: 4,
          elevation: 5
        }}>
          <Text style={{
            fontSize: 18,
            fontWeight: 'bold',
            color: '#fff',
            marginBottom: 10,
            textAlign: 'center'
          }}>
            {confirmation.title}
          </Text>
          
          <Text style={{
            fontSize: 14,
            color: '#fff',
            marginBottom: 20,
            textAlign: 'center',
            lineHeight: 20
          }}>
            {confirmation.message}
          </Text>

          <View style={{
            flexDirection: 'row',
            justifyContent: 'space-around',
            gap: 10
          }}>
            <TouchableOpacity
              style={{
                backgroundColor: '#95a5a6',
                padding: 12,
                borderRadius: 5,
                flex: 1,
                alignItems: 'center'
              }}
              onPress={handleCancel}
            >
              <Text style={{
                color: '#fff',
                fontWeight: 'bold',
                fontSize: 16
              }}>
                Cancel
              </Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={{
                backgroundColor: '#2ecc71',
                padding: 12,
                borderRadius: 5,
                flex: 1,
                alignItems: 'center'
              }}
              onPress={handleConfirm}
            >
              <Text style={{
                color: '#fff',
                fontWeight: 'bold',
                fontSize: 16
              }}>
                Yes, Add to Database
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
} 